export const FILTER_TAGS = {
  icon: 'tag',
  title: 'Status',
};
